import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-59e48cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Support de cours "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "text-info"
}
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Module "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "text-info"
}
const _hoisted_12 = { class: "col-md-12 mt-5" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "testForm",
        onSubmit: _ctx.generateRandomTest,
        "validation-schema": _ctx.testSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, { name: "supportDeCours" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.supportOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.formData.supportDeCours,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.supportDeCours) = $event))
                    }, field, {
                      onChange: _ctx.onSupportChange,
                      placeholder: "Sélectionner un support",
                      disabled: _ctx.isLoadingSupports
                    }), null, 16, ["options", "modelValue", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "supportDeCours",
                  class: "text-danger"
                }),
                (_ctx.isLoadingSupports)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_7, "Chargement..."))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, { name: "module" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.moduleOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.formData.module,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.module) = $event))
                    }, field, {
                      placeholder: "Sélectionner un module",
                      disabled: !_ctx.formData.supportDeCours || _ctx.isLoadingModules
                    }), null, 16, ["options", "modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "module",
                  class: "text-danger"
                }),
                (_ctx.isLoadingModules)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Chargement des modules..."))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["btn btn-info me-3", { 'cursor-not-allowed': _ctx.isDisableGenerate }]),
                disabled: _ctx.isDisableGenerate
              }, " Générer le test ", 10, _hoisted_14),
              _createVNode(_component_router_link, {
                to: "/liste-sessions",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Annuler ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}